import { getI18nInstance } from '@wkda/funnel-components';
import { messages } from '../../translations/wkda-sf/pl/messages';
import config from '../config';

/**@type {String} */
const locale = config.locale;

export async function activate() {
  // @ts-ignore
}

export function initializeI18n(i18n = getI18nInstance()) {
  // @ts-ignore
  i18n.load(locale, messages);
  i18n.activate(locale);
}
